
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Oku kuziswe yi
                    <a href="${0}">Folksonomy Engine project</a>. Sukuthi
                    uthandabuza ukuthatha inxaxheba okanye ukunika ingxelo`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Esi sixhobo sikuvumela ukuba ulungise uluhlu lwezithako. Ungadibanisa, ususe okanye uhlele
                uluhlu lwezithako.
                <br>
                Lo mlinganiswa <span class="highlight">␣</span> umele isithuba.
                <br>
                Lo mlinganiswa <span class="highlight">↩︎</span> umele ikhefu lomgca. `,
'hb28f1f2ec1744ee9': html`Ezi zakhiwo zenziwe kwaye zifakwe ngabasebenzisi kulo naluphi na uhlobo lokusetyenziswa. Zive
                    ukhululekile ukongeza eyakho. Iipropati kunye namaxabiso owadalayo
                    <strong>kufuneka ibeyinyani</strong>. Ungantywila ngaphakathi
                    <a href="${0}">kuluhlu lweepropati esele zisetyenziswe luluntu</a>
                    okanye uphonononge i
                    <a href="${1}">iipropathi zoxwebhu kunye nenjini yokukhangela</a>.`,
's000a5b76bd3a01c2': `Ilayisha iipropati...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `Sincede izithako`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Qinisekisa isityalo`,
's03e9c8114521b998': `Ndiza kuhlela izithako`,
's05ec315d9308091a': `Ikona yebhakhowudi yeekona`,
's061eb5af92512c85': `Igciniwe! Unganceda ngenye?`,
's06847c221c4c0bc1': `Ndingathanda ukwenza ipropathi ukuze [chaza imeko yakho yokusetyenziswa]...`,
's06f6c6f99db6b552': `Eyoqobo`,
's081e2ad82db71e1d': `Iinqobo ezisemgangathweni`,
's09205907b5b56cda': `No`,
's0b4235aae602a950': `amaxwebhu anikezelweyo`,
's0bb2d48532acc455': `Khuphela i-CSV`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `Umfanekiso ongasebenziyo`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Rhoxisa isivuno`,
's11a18a69b30b65ed': `Sincede silungise iimpazamo kuluhlu lwezithako`,
's1205d5f6fccf8e69': `Ixabiso lePropati`,
's15d64a0a6715285a': `Isitshixo esitsha`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Indawo yokukhetha`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Sincede silungise ulwazi lwezondlo`,
's1e00019dc454872d': `Nceda unikeze igama lepropati usebenzisa uphawu lwegama lepropati.`,
's1e49126af0935a5b': `Uluhlu lweemveliso ezisebenzisa le propati`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `Bhala ipropati`,
's300b3a6ee4e1252d': str`Umdlalo ombi ${0}%`,
's33f786bb6b4f0cf4': `Iziphumo zesityalo`,
's33f85f24c0f5f008': `Save`,
's34be4af4e8fec4ae': `Buza uluntu kuqala`,
's36d86adc823cbfa6': `Phambi kokudala indawo entsha, xoxa ngayo noluntu:`,
's3781d25aa51a736c': `Uxwebhu lweNjini yeFolksonomy`,
's383ae4449428b61e': `Seta kwakhona isityalo`,
's39bcf88721a1e8ee': `Lungisa kwakhona ukhetho`,
's39e14e14300694c7': `Amaxwebhu kunye neziKhokelo`,
's3b430cfa5c1fe7f4': str`Uxwebhu lwe ${0}`,
's3f4e4b52f230a892': `Ikhanvasi yomfanekiso`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `Umfanekiso osembindini`,
's42dd66b2441566fd': `Uphawu lombindi`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's453ab0dbb9b5c777': `Hlaziya ubungakanani obufanelekileyo`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Ubalo lweMveliso`,
's4df2f533c0c1e7d0': `Ulawulo lwemifanekiso`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Hambisa ukhetho`,
's4f751fb9b3ed766c': `Ukudala iPropati eNtsha`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Ngenisa igama lepropati...`,
's55d7249883a98ca1': `malunga nale propati kwi-Open Food Facts wiki`,
's565867d84c04aea2': `Iipropati zesihluzi...`,
's5666afe5cd0166de': `Nceda ulungise iimpazamo okanye uguqule okubhaliweyo phambi kokuqinisekisa`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Ilayisha iimveliso...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Sincede silungise ulwazi lwezondlo.`,
's5dd6f12783fca34f': `Hlela uluhlu lwezithako`,
's5e8250fb85d64c23': `Close`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `Umfanekiso osikiweyo`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Umdlalo olungileyo ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `Amaxwebhu`,
's787dd11bed0dc88a': `Hlaziya ubungakanani ngasekhohlo`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `Funda ngakumbi malunga nokudalwa kwepropati kunye nezikhokelo:`,
's8038273de2cf8b73': `Nceda ukhethe ummandla oza kuwunqamla.`,
's839cc2908a5387f2': `Hluza iikhowudi zebhakhowudi...`,
's86197dcf3e96af64': `Khangela kwaye ukhangele iimpawu ezikhoyo`,
's8a63be30a129a59c': `Phinda wenze ubungakanani emazantsi`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Phinda wenze ubungakanani phezulu ngasekunene`,
's8db84aa4bc949af2': `Bhala iPropati eNtsha`,
's8f839a03997a16d7': `Jonga iMveliso`,
's901ae1e236ac45d3': `Rhoxisa ukucinywa`,
's907f7a97c6b29425': `Qaphela ukuba imodeli yedatha inokuguqulwa. Sebenzisa ngomngcipheko wakho.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Izithako :`,
's9a7f60fce090ecaf': `Akuphumelelanga ukulayisha iipropati. Nceda uzame kwakhona mva.`,
's9b87abd68fb9df45': `Ayifunyanwa? Yenza isitshixo esitsha {value}`,
's9c0f52425fd2f07e': `Isenokungangqinelani`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `Akukho manqaku akhoyo`,
'sa548778b24054030': `Jonga zonke iipropathi ezinegalelo kwiprojekthi yeNjini yeFolksonomy. Ezi zakhiwo zibonelela ngemethadatha eyongezelelweyo kunye nokuqonda malunga neemveliso kwi-Open Food Facts database.`,
'sa63907958bd0ec4b': `Phinda ubungakanani phezulu ngasekhohlo`,
'sa95b4224f685a36a': `Vala imodali`,
'sab56a1d439576fd6': `I icon yengcebiso`,
'sac47ea2901d04c15': `Phinda wenze ubungakanani emazantsi asekhohlo`,
'sb125227d436c2925': `Phendla umxholo wepropati yakho kwisiseko sedatha yepropati ekhoyo:`,
'sb125568d43642e6f': `Phendula imibuzo malunga nemveliso.`,
'sb1c538e038f9b214': str`Umdlalo olungileyo kakhulu ${0}%`,
'sb28639570ff3b852': `uluhlu lwazo zonke iipropati`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Nje ukuba uqinisekisile ukuba ipropathi yakho ayikho kwaye noluntu luyavuma ukuba iluncedo, kufuneka uqale uyibhale kwiwiki.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `Akukho mveliso zifunyenweyo kule ndawo.`,
'sb7f72e4c8a2d3357': `Amaxabiso okucoca...`,
'sb8178320160f84ea': `Bonisa isityalo`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Zonke iimbono ziphendulwe! Enkosi ngoncedo lwakho!`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sbe472dc3c2685985': `Ixabiso elingqinelanayo`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Phinda umlinganiselo ophezulu`,
'sc1c08d0cbcc3bd24': `Ayihambelani`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Ulungiso olucetyiswayo`,
'sc681b137e8f604f7': `Confirm deletion`,
'sc6daf8a31883f8b9': `Hambisa umfanekiso`,
'sc895972c88d38ca5': `Ipropati yeFolksonomy`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Imiqolo yetyu`,
'scb3b0671d7b7f640': `Ixabiso elitsha`,
'scb489a1a173ac3f0': `Yes`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Joyina iNgxoxo yeSlack`,
'scdb6cad0b92721bf': `Akukho zakhiwo zifunyenweyo.`,
'scf23a05631f93732': `Qinisekisa Cima`,
'scfed2f270ef6a3aa': `Khetha indawo`,
'sd1022bc1ef9204f7': `Umfanekiso onokusondezwa`,
'sd1077c055cf9ba6b': `Sincede siqinisekise uluhlu lwezithako zemveliso.`,
'sd698d21ddecba56b': `Hayi! Ungasinceda siphucule ulwazi lwemveliso ngokuphendula la macandelo alandelayo:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Khangela ukuba umhlaba sele ukhona na`,
'sdbf806fefc584115': `Kufuneka ufumane a`,
'sdc673e73b5c13aea': `Delete`,
'sdc792b75f1edcaba': `Sincede silungise upelo lwezithako.`,
'sdca5deead576ceee': `Yenza ubungakanani obusezantsi ekunene`,
'sdcc2555c5dde524f': `Uqinisekile ufuna ukucima le nto? Esi senzo asinakuphinda singenziwa.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `Ayisebenzi`,
'se5127cf0f92e7e48': `Icebiso: ungayifumana kwakhona`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Ndiza kucebisa isityalo esingcono`,
'seea3800e27baa686': `Iimveliso zomntu ngamnye`,
'sefaba4adc4ec9219': `Iipropati zeFolksonomy`,
'seffa8ca49175b5f0': `Iipropati ezenzelwe wena`,
'sf44a6b3b232c28ea': str`Buyisela ixabiso langoku nge ${0}`,
'sf4cd86a2f5ef2588': `Ibhakhowudi yeMveliso`,
'sf57a61152168cc81': `Sincede silungise ubhaqo lwesithako`,
'sf88b90b8ba23871c': `Umdlalo ongaziwayo`,
'sf9aee319a006c9b4': `Add`,
'sfacbbe968fa7d773': `Igama lePropati`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Ixabiso elihambelanayo`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  